'use strict';
import angular from 'angular';

angular.module('packages.services', [])
.service('PackagesService', PackagesService)
.service('PackagesFactory', PackagesFactory);

PackagesService.$inject = ['PackagesFactory', '$q', 'Upload', 'AppConfig', '$http', '$filter'];

function PackagesService(PackagesFactory, $q, Upload, AppConfig, $http, $filter) {
    let service = {};
    
    service.Packages = null;
    service.Clusters = null;

    service.validateAndFormatData = function(data, template){
        let error = undefined;
        if (template.data_type == 'json') {
            data.field_values = template.field_values;
        }
        else if(template.data_type == 'date'){
            data.field_values =  JSON.stringify([$filter('date')(template.field_values, "yyyy-MM-dd")]);
        }
        else if(template.input_type == 'timeselect'){
            data.field_values = JSON.stringify([String($filter('date')(template.field_values, "HH:mm")) + ":00"]);
        }
        else if (template.input_type == "multiselect" || template.input_type == "multiselect-custom") {
            data.field_values = JSON.stringify(template.field_values);
        }
        else {
            let field_value = template.field_values;
            if (template.data_type == 'currency') {
                field_value = field_value.replace('$','');
                field_value = field_value.replace(/[^\d.\-]/g, '');
                if (isNaN(field_value) || field_value == '') {
                    error = 'Invalid currency value: ' + field_value;
                }
            } else if (template.data_type == 'integer') {
                field_value = field_value.replace(/[^\d.\-]/g, '');
                if (isNaN(field_value) || field_value == '') {
                    error = 'Invalid integer value: ' + field_value;
                }
            } else if (template.data_type == 'decimal') {
                field_value = field_value.replace(/[^\d.\-]/g, '');
                if (isNaN(field_value) || field_value == '') {
                    error = 'Invalid decimal value: ' + field_value;
                }
                template.field_values = field_value;
            } else if (template.data_type == 'percentage') {
                field_value = field_value.replace('%','');
                field_value = field_value.replace(/[^\d.\-]/g, '');
                if (isNaN(field_value) || field_value == '') {
                    error = 'Invalid percentage value: ' + field_value;
                }
                template.field_values = field_value + '%';
            }

            data.field_values = JSON.stringify([field_value]);
        }

        return error;
    };

    service.getPackages = function(activeId) {
        var deferred = $q.defer();
        PackagesFactory.Packages().get({
            'active': activeId
        }).$promise.then(function(data) {
            service.Packages = data.data;
            deferred.resolve();
        }, function(response) {
            console.log("error getting packages");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.AddPackages = function(params) {
        var deferred = $q.defer();

        PackagesFactory.packagesData().save({
            'types': 'type'
        }, params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error Adding Packages");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.saveProductFields = function(params) {
        var deferred = $q.defer();

        PackagesFactory.ProductField().save(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error Saveing product fields");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.updateProductFields = function(params,fieldid) {
        var deferred = $q.defer();

        PackagesFactory.UpdateProductField(fieldid).update(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error Updating product fields");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.updatePackages = function(params,editPackageId) {
        var deferred = $q.defer();

        PackagesFactory.editPackagesData(editPackageId).update(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error updating Packages");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.getProductFields = function(productId) {
        var deferred = $q.defer();

        PackagesFactory.productfields().get({
            'product_id': productId,
            'all': true,
        }).$promise.then(function(data) {
            deferred.resolve(data.data);
        }, function(response) {
            console.log("error Geting Product Fields ");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.getClusters = function(productId){
        var deferred = $q.defer();
        PackagesFactory.clusters(productId).get().$promise.then(function(data) {
            service.Clusters = data.data
            deferred.resolve();
        }, function(response) {
            console.log("error getting packages");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.getEditproductfields = function(product_package_id){
        var deferred = $q.defer();
        PackagesFactory.getEditProductField(product_package_id).get().$promise.then(function(data) {
            deferred.resolve(data.data);
        }, function(response) {
            console.log("error getting packages");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.deletePackage = function(packageId) {
        var deferred = $q.defer();

        PackagesFactory.deletePackagesData(packageId).delete().$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error deleting packages " + response.data.id);
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.deleteProductFields = function(productFieldId) {
        var deferred = $q.defer();

        PackagesFactory.deleteProductField(productFieldId).delete().$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error deleting packages " + response.data.id);
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.importPackages = function(customFile) {
        var deferred = $q.defer();
        Upload.upload({
            url: AppConfig.API_URL + 'packages/importPackages',
            file: customFile
        }).success(function(data, status, headers, config) {
            if (data.result){
                deferred.resolve(data.result);
            }else{
                deferred.reject();
            }
        }).error(function(error) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.exportPackages = function() {
        var deferred = $q.defer();
        $http.get(AppConfig.API_URL + 'packages/packageFieldValue?export_to_csv=csvdata').then(function(response) {
            deferred.resolve(response);
        }, function(error){
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getlookupcontents = function(key){
        var deferred = $q.defer();
        $http.get(AppConfig.IO_API_URL + 'lookups/contents?contentKey='+key).then(function(response) {
            deferred.resolve(response);
        }, function(error){
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getlookupcontentsByFieldName = function(field_name){
        var deferred = $q.defer();
        $http.get(AppConfig.API_URL + 'lookupcontent/?field_name='+field_name).then(function(response) {
            deferred.resolve(response);
        }, function(error){
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getlocationData = function(id){
        var deferred = $q.defer();
        $http.get(AppConfig.IO_API_URL + 'api/geoLocationForAllCluster?id='+id).then(function(response) {
            deferred.resolve(response);
        }, function(error){
            deferred.reject();
        });

        return deferred.promise;
    };

return service;

}

PackagesFactory.$inject = ['$resource', 'AppConfig'];

function PackagesFactory($resource, AppConfig) {

    var factory = {};

    factory.Packages = function() {
        return $resource(AppConfig.API_URL + 'packages/?',null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };
    factory.clusters = function(productId) {
        return $resource(AppConfig.API_URL + 'clusters/product/'+productId ,null,{
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.deleteProductField = function(productFieldId) {
        return $resource(AppConfig.API_URL + 'packages/packageFieldValues/'+productFieldId ,null,{
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getEditProductField = function(product_package_id) {
        return $resource(AppConfig.API_URL + 'packages/packageFieldValue?product_package_id='+product_package_id ,null,{
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.ProductField = function() {
        return $resource(AppConfig.API_URL + 'packages/packageFieldValues',null,{
            'save': {
                method: 'POST'
            }
        });
    };

    factory.UpdateProductField = function(productFieldId) {
        return $resource(AppConfig.API_URL + 'packages/packageFieldValues/'+productFieldId,null,{
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.productfields = function() {
        return $resource(AppConfig.API_URL + 'productfield/',null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    

    factory.packagesData = function() {
        return $resource(AppConfig.API_URL + 'packages/', null, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.deletePackagesData = function(packageId) {
        return $resource(AppConfig.API_URL + 'packages/' + packageId, null, {
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.editPackagesData = function(packageId) {
        return $resource(AppConfig.API_URL + 'packages/' + packageId, null, {
            'update': {
                method: 'PUT'
            }
        });
    };

   

    return factory;

}